import { Box } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { ToolContext } from '../../../../../../core/context/ToolContext';
import { Confirmation } from './mystyles/Confimation';
import { RealProperty } from './realproperty/Index';
import { Top } from './Top';
import { Side } from './Side';
import { env } from '../../../../../../core/Env';
import { rqx } from '../../../../../../core/request/API';
import { S3 } from '../../../../../../core/transmit/S3';

export const WebCustomization = () => {
    const { website_state, tool_state } = useContext(ToolContext);
    const { themeBtn, templateForm, showPicker, showSidebar, sideBarContent, tLoader } = website_state;
    const { userId, __SESSION } = tool_state
    const urlParams = new URLSearchParams(window.location.search);
    const tab = urlParams.get("tab");
    const method = urlParams.get("method");
    const nav = useHistory();
    const company_id = __SESSION.data.uaccess[0].company_id
    const handleThemes = (t, m) => {
        const thm = themeBtn.data;
        const sb = themeBtn.data;
        const pick = showPicker.data
        if (t === 'theme') {
            nav.push(`/campaign/website/customization?tab=mobile&method=${m}&menu=property-rent&property-type=all`)
            themeBtn.set({ ...thm, theme: true });
        } else if (t === 'option') {
            showSidebar.set(false);
            themeBtn.set({ ...thm, themeOption: !thm.themeOption });
            sideBarContent.set({ ...sb, site_identity: false, })
        } else if (t === 'site_colors') {
            showSidebar.set(true);
            showPicker.set({ ...pick, buttons: { bg: true, colors: true, palletPicker: true }, })
            sideBarContent.set({ ...sideBarContent.data, site_identity: false, site_color: true, })
        }
        else if (t === 'identity') {
            showSidebar.set(true);
            sideBarContent.set({ ...sb, site_identity: true, site_color: false })
            themeBtn.set({ ...thm, themeOption: false });
            showPicker.set({ ...pick, buttons: { bg: false, colors: false }, })
        } else {
            themeBtn.set({ ...thm, theme: false, themeOption: false, site: { identity: false } });
            showSidebar.set(false);
            sideBarContent.set({ ...sideBarContent.data, site_identity: false })
            nav.push(`/campaign/website/customization?tab=mobile&menu=property-rent&property-type=all`)
        }
    }
    const closeSidebar = (t) => {
        showSidebar.set(false);
        showPicker.set({ ...showPicker.data, buttons: { bg: false, colors: false }, header: { bg: false, btn: { bg: false, color: false }, title_color: false } })
        themeBtn.set({ ...themeBtn.data, themeOption: t === 'sc'? true : false, site: { identity: false } });
        sideBarContent.set({ ...sideBarContent.data, site_identity: false })
    };
    const togglePicker = (show) => {
        const sd = showPicker.data
        if (show === 'for-header-bgcolor') {
            showPicker.set({ ...sd, header: { ...sd.header, bg: true } });
        } else {
            showPicker.set({
                ...sd, header: { ...sd.header, btn: { ...sd.header.btn, bg: true } },
            });
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        const np = name.split('.');
        const utf = { ...templateForm.data };
        let temp = utf;
        np.forEach((part, index) => {
            if (index === np.length - 1) {
                if (["top.title", "logo", "website_link"].includes(name)) {
                    temp[part] = {
                        value,
                        ...(name === "top.title" ? { font_size: 18 } : {}),
                        stat: value === '',
                        msg: value === '' ? 'This field is required.' : ''
                    };
                } else {
                    temp[part] = value;
                }
            } else {
                temp[part] = temp[part] || {};
                temp = temp[part];
            }
        });
        templateForm.set({ ...utf });
    };
    const [errors, setError] = useState({ title: false, logo: undefined, link: false });
    const validate = () => {
        const vldt = templateForm.data;
        const newErrors = {
            title: vldt.top.title.value === '',
            logo: vldt.logo.value === undefined,
            link: vldt.website_link.value === '',
        };
        setError(newErrors);
        return !newErrors.title && !newErrors.logo && !newErrors.link;
    };
    const openModal = (t, s, m) => {
        const tf = { ...templateForm.data };
        if (t === 'submit' && validate()) {
            templateForm.set({
                ...tf,
                submit: { modal: true, type: t, status: s, typeModal: m, confirmed: false }
            });
        } else {
            templateForm.set({
                ...tf,
                submit: { modal: false, type: 0, status: 0, typeModal: "", confirmed: false }
            });
        }
    };

    const __init = async () => {
        tLoader.set(true);
        let t;
        const primaryRes = await rqx.get(`<<tool>>/${env()}/realPropertyWebsite/read`, { company_id: company_id });
        //const primaryRes = []
        if (primaryRes.length > 0) {
            t = primaryRes;
        } else {
            t = await rqx.get(`<<tool>>/${env()}/templateLists/read`, { id: 2 });
        }
        // BACK IT TO JSON.parse(t[0].properties) the line below that has a 1 
        // ALSO UNCOMMENT let list, listData, list: listData,
        let designs = primaryRes.length > 0 ? JSON.parse(t[0].properties) : JSON.parse(t[0].designs);
        let list = primaryRes.length > 0 ? designs.list : designs.property;
        let properties = primaryRes.length === 0 ? designs.property : [];
        let topBar = primaryRes.length > 0 ? designs.top : designs.top_bar;
        let siteBtns = primaryRes.length > 0 ? designs.site_btns : designs.site_btns;
        const propertyData = properties.map((p) => ({
            id: p.id,
            link: p.coverPhoto.object,
            name: p.title.value,
            city_name: p.location.city,
            province_name: p.location.province,
            description: p.description.value,
            price: p.price.value,
        }));
        const listData = list.map((p) => ({
            id: p.id,
            offer_type: p.offer_type,
            property_type: p.property_type,
            title: { value: p.title.value, stat: true, msg: '' },
            description: { value: p.description.value, stat: true, msg: '' },
            location: { value: p.location.value, stat: true, msg: '' },
            block: { value: p.block.value, stat: true, msg: '' },
            floor_number: { value: p.floor_number.value, stat: true, msg: '' },
            price: { value: p.price.value, stat: true, msg: '' },
            coverPhoto: { value: p.coverPhoto.value, object: p.coverPhoto.object, name: p.coverPhoto.name, type: p.coverPhoto.type, size: p.coverPhoto.size, updated: false, stat: true, msg: '' },
            contact_details: p.contact_details,
            indoor: p.indoor,
            outdoor: p.outdoor,
            land_mark: p.land_mark,
            normal_photos: p.normal_photos,
        }));
        templateForm.set((p) => ({
            ...p,
            status: t[0].status,
            id: t[0].template_id === undefined ? "" : t[0].id,
            template_id: t[0].template_id === undefined ? t[0].id : t[0].template_id,
            device_type: t[0].device_type,
            submit: { modal: false, type: 0, confirmed: false },
            own_domain: { value: '', stat: false, msg: '' },
            website_link: { value: designs.website_link.value, stat: false, msg: '' },
            list: listData,
            staticList: propertyData, 
            top: {  
                bg_color: topBar.bg_color,
                buttons: { bg: topBar.button.bg, color: topBar.button.color },
                title: { value: topBar.title.value, font_size: topBar.title.fontsize },
            },
            logo: { value: t[0].link, object: t[0].link, name: t[0].name, size: t[0].size, type: t[0].type, updated: false, stat: false, msg: '' },
            site_btns: { bg: siteBtns.bg, color: siteBtns.color },
            logText: { lognIn: '', logOut: '' },
            signText: { signIn: '', signOut: "SignOut" },
        }));
        tLoader.set(false);
    };
    useEffect(() => {
        __init();
        // eslint-disable-next-line
    }, [])

    const proceedHandler = async () => {
        const utd = templateForm.data;
        templateForm.set({ ...utd, submit: { modal: utd.submit.modal, type: utd.submit.type, status: utd.submit.status, typeModal: utd.submit.typeModal, confirmed: true } });
        const uploadImage = async (image) => {
            if (image && image.value && image.updated) {
                const result = await S3([image.value]);
                return {
                    value: result.location,
                    size: image.size,
                    name: image.name,
                    type: image.type
                };
            }
            return image;
        };
        const logo = await uploadImage(utd.logo);
        const b = {
            id: method === 'create' ? '' : utd.id,
            template_id: utd.template_id,
            status: utd.submit.status,
            properties: {
                list: utd.list,
                website_link: { value: utd.website_link.value },
                top: {
                    button: {
                        bg: utd.top.buttons.bg, color: utd.top.buttons.color,
                    },
                    title: { value: utd.top.title.value, fontsize: utd.top.title.font_size },
                    bg_color: utd.top.bg_color,
                },
                site_btns: { bg: utd.site_btns.bg, color: utd.site_btns.color }
            },
            logo: logo,
            device_type: tab === 'mobile' ? 1 : tab === 'desktop' ? 2 : 3,
            company_id: company_id,
            userId: userId.data
        }
        const s = await rqx.post(`<<tool>>/${env()}/realPropertyWebsite/${method}`, b);
        if (s.message === 'success') {
            if (method === 'create') {
                templateForm.set((prev) => ({
                    ...prev,
                    id: s.id,
                    submit: { modal: false, type: 0, status: 0, confirmed: false },
                    template_id: utd.template_id,
                    status: utd.submit.status,
                    properties: {
                        list: utd.list,
                        website_link: { value: utd.website_link.value },
                        top: {
                            button: {
                                bg: utd.top.buttons.bg, color: utd.top.buttons.color
                            },
                            title: { value: utd.top.title.value, fontsize: utd.top.title.font_size },
                            bg_color: utd.top.bg_color,
                        },
                        site_btns: { bg: utd.site_btns.bg, color: utd.site_btns.color }
                    },
                    logo: logo,
                    device_type: tab === 'mobile' ? 1 : tab === 'desktop' ? 2 : 3,
                    company_id: company_id,
                    userId: userId.data,
                }))
            }
            __init();
            nav.push(`/campaign/website/customization?tab=mobile&method=update&menu=property-rent&property-type=all`)
        }
    }

    useEffect(() => {
        nav.push(`/campaign/website/customization?tab=mobile&menu=property-rent&property-type=all`)
        if (method === null) {
            themeBtn.set({ ...themeBtn, theme: false, themeOption: false, site: { identity: false } });
        }
        __init()
        // eslint-disable-next-line
    }, []) 

    return (
        <Box width="100%" height="100%" display="flex" alignItems="center" >
            <Box width={250} height="100%" display="flex" bgcolor="linear-gradient(to bottom right, #f0f0f0, #e0e0e0)">
                <Side
                    method={method}
                    togglePicker={togglePicker}
                    showPicker={showPicker}
                    themeBtn={themeBtn}
                    openModal={openModal}
                    handleChange={handleChange}
                    templateForm={templateForm}
                    handleThemes={handleThemes}
                    sideBarContent={sideBarContent}
                    showSidebar={showSidebar}
                    closeSidebar={closeSidebar}
                    company_id={company_id}
                    errors={errors}
                    tLoader={tLoader}
                />
            </Box>
            <Box width="100%" height="100%" display="flex" alignItems="center" flexDirection="column" >
                <Box width="100%" height="6%">
                    <Top themeBtn={themeBtn} tLoader={tLoader} templateForm={templateForm} company_id={company_id} handleThemes={handleThemes}/>
                </Box>
                <Box width="100%" height="94%">
                    <RealProperty tab={tab} />
                    <Confirmation templateForm={templateForm} openModal={openModal} proceedHandler={proceedHandler} />
                </Box>
            </Box>
        </Box>
    );
};
